import { queryOptions, useQuery, UseQueryOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { domain } from "../config";
import {
  getOrganizationDetails,
  getOrganizationDetailsById,
} from "../portal-api";
import { getSubdomain } from "./getSubdomain";
import { Organization, PortalError } from "./types";

const baseOrganizationsQueryKey = ["organizations"] as const;

const subdomain = getSubdomain(domain);

export function getQueryKeyForOrganization(id: number | null | undefined) {
  return [...baseOrganizationsQueryKey, id ?? null] as const;
}

export function getQueryForActiveOrganization<T = Organization>(
  _queryOptions?: Partial<
    UseQueryOptions<Organization, AxiosError<PortalError>, T>
  >,
) {
  return queryOptions({
    queryKey: [...baseOrganizationsQueryKey, subdomain],
    queryFn: () => getOrganizationDetails(subdomain),
    // the organization details shouldn't change during the lifetime of the app
    staleTime: Infinity,
    ..._queryOptions,
  });
}

export function useActiveOrganizationQuery<T = Organization>(
  _queryOptions?: Partial<
    UseQueryOptions<Organization, AxiosError<PortalError>, T>
  >,
) {
  return useQuery(getQueryForActiveOrganization(_queryOptions));
}

export function useOrganizationQuery(id: Organization["id"]) {
  return useQuery<Organization, AxiosError<PortalError>>({
    queryKey: getQueryKeyForOrganization(id),
    queryFn: () => getOrganizationDetailsById(id),
    // the organization details shouldn't change during the lifetime of the app
    staleTime: Infinity,
  });
}
